<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-row dense v-if="user.tipo == 'ADMIN'">
      <v-col cols="12" sm="12" md="6">
        <v-select
          outlined
          dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
          @input="carregaLojistas"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-select
          outlined
          dense
          v-model="lojistaSelecionado"
          :items="lojistas"
          item-text="nome"
          item-value="id"
          label="Selecione o lojista"
          @input="carregaProdutos(empresaSelecionada, lojistaSelecionado)"
        ></v-select>
      </v-col>
    </v-row>
    <v-row dense v-if="user.tipo == 'ADMIN_PRODUTORA'">
      <v-col cols="12" sm="12" md="6">
        <v-select
          outlined
          dense
          v-model="lojistaSelecionado"
          :items="lojistas"
          item-text="nome"
          item-value="id"
          label="Selecione o lojista"
          @input="carregaProdutos(user.empresaId, lojistaSelecionado)"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col ls="12" sm="12" md="12" lg="12">
        <v-data-table
          :search="tabela.busca"    
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          class="elevation-1"
          style="border-radius: 10px;"
          :loading="tabela.carregamento"
          loading-text="Buscando itens..."
          :footer-props="{
            'items-per-page-text': 'Linhas por página',
            'items-per-page-all-text': 'Tudo',
          }"
        >
          <template v-slot:[`item.status`]="{ item }">
            <p style="margin: 0px">{{item.status == "ativo" ? 'Ativo' : 'Inativo'}}</p>
          </template>
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">PRODUTOS</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="tabela.busca"
                append-icon="search"
                label="Pesquisa"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogoProduto = true" tile color="#00253E" :disabled="user.tipo == 'ADMIN' ? (empresaSelecionada == '' || lojistaSelecionado == '') : false">
                <v-icon left dark>add_circle</v-icon>Adicionar Produto
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.preco`]="{ item }">
            <p style="margin: 0px">R$ {{item.preco}}</p>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-btn color="teal" icon @click="editItem(item)">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn color="red" icon @click="deleteItem(item)">
              <v-icon>delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>

      <!-- CARD INSERE Produtos -->
      <v-dialog v-model="dialogoProduto" persistent max-width="600px">
        <v-card>
          <v-card-title>{{ formTitleProd }}</v-card-title>
          <v-card-subtitle>*O preenchimento de todos os campos é obrigatório</v-card-subtitle>
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <v-text-field v-model="produto.descricao" outlined label="Descrição" color="#94AAB4" hide-details dense></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="produto.detalhes" outlined label="Detalhes" color="#94AAB4" hide-details dense></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="produto.ordem" outlined label="Ordem" color="#94AAB4" hide-details dense></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field :key="produto.id || 'novo'" v-model="produto.preco" prefix="R$" outlined label="Preço" color="#94AAB4" hide-details dense v-money="money" type="tel" id="campoValor"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field v-model="produto.estoque" type="tel" outlined label="Estoque" color="#94AAB4" hide-details dense></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field v-model.number="produto.estoqueMinimo" type="tel" outlined label="Estoque Mínimo" color="#94AAB4" hide-details dense></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-switch style="margin-top: 1px" v-model="produtoAtivo" label="ATIVO" color="#00253E" hide-details></v-switch>
              </v-col>
              <v-col cols="12">
                <v-select outlined dense v-model="produto.categoriaId" :items="categorias" item-text="descricao" item-value="id" label="Categoria" hide-details></v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="produto.urlImagem" outlined label="URL Imagem" color="#94AAB4" hide-details dense></v-text-field>
                <v-img contain :src="produto.urlImagem" height="100" width="100%" v-if="produto.urlImagem" style="max-width: 100%; max-width: 130px; margin-top: 10px" class="mx-auto"></v-img>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="salvarProduto">Salvar</v-btn>
            <v-btn text color="red" @click="dialogoProduto = false">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import { VMoney } from 'v-money'
  export default {
    components: {Snackbar},
    data: () => ({
      date: new Date().toISOString().substr(0, 10),
      mask:"##:##:##",
      menu: false,
      menu2: false,
      search:'',
      addUser: false,
      cadastroCategoria: false,
      dialogoProduto: false,
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Ordem', value: 'ordem' },
          { text: 'Descrição', value: 'descricao' },
          { text: 'Detalhes', value: 'detalhes' },
          { text: 'Preço', value: 'preco' },
          { text: 'Status', value: 'status' },
          { text: 'Ações', value: 'action',  sortable: false, align: 'center' },
        ],
        carregamento: false,
        conteudo: [],
      },
      empresaSelecionada: '',
      lojistaSelecionado: '',
      empresas: [],
      perfis: [],
      editedIndex: -1,
      produto: {
        descricao: "",
        detalhes: "",
        preco: "",
        status: "ativo",
        estoque: 0,
        urlImagem: "",
        empresaId: "",
        lojistaId: "",
        ordem: "",
        categoriaId: "",
        estoqueMinimo: 0,
      },
      produtoDefault: {
        descricao: "",
        detalhes: "",
        preco: "",
        status: "ativo",
        estoque: 0,
        urlImagem: "",
        empresaId: "",
        lojistaId: "",
        ordem: "",
        categoriaId: "",
        estoqueMinimo: 0,
      },
      produtos: [],
      lojistas: [],
      events: [],
      categorias: [],
      produtoAtivo: true,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitleProd () {
        return this.editedIndex === -1 ? 'Adicionar novo produto' : 'Editar produto'
      },  
    }),

    watch: {
      dialogoProduto(val) {
        if (val == false) {
          setTimeout(() => {
            this.produto = Object.assign({}, this.produtoDefault)
            this.produtoAtivo = true
            this.editedIndex = -1
          }, 300)
        }
      },

      produtoAtivo(val) {
        if (val) {
          this.produto.status = "ativo"
        } else {
          this.produto.status = "inativo"
        }
      },
    },

    mounted () {
      if (this.user.tipo == 'ADMIN') {
        this.carregaEmpresas()
      } else if (this.user.tipo == 'ADMIN_PRODUTORA') {
        this.carregaLojistas(this.user.empresaId)
      } else {
        this.carregaProdutos(this.companyobj.id, this.user.lojistaId)
      }
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaLojistas(empresaId) {
        await axios.get(baseApiUrl + 'Lojistas?filter={"where":{"empresaId":"' + empresaId + '"}, "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.lojistas = response.data
          }
        })
      },

      async carregaProdutos(empresaId, lojistaId) {
        this.tabela.carregamento = true
        this.tabela.conteudo = []
        this.carregaCategorias(empresaId, lojistaId)
        
        await axios.get(baseApiUrl + 'Produtos?filter={"where":{"and":[{"lojistaId":"' + lojistaId + '"}]}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          this.tabela.conteudo = response.data
          this.tabela.carregamento = false
        })       
      },

      async carregaCategorias(empresaId, lojistaId) {
        await axios.get(baseApiUrl + 'Categorias?filter={"where":{"and":[{"empresaId":"' + empresaId + '"},{"lojistaId":"' + lojistaId + '"}]}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          this.categorias = response.data
        })
      },

      editItem(item) {
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.produto = Object.assign({}, item)
        this.produtoAtivo = this.produto.status == 'ativo' ? true : false
        this.dialogoProduto = true
      },

      async deleteItem(item) {
        var r = confirm('Deseja realmente excluir o produto: ' + item.descricao + '?')
        if (r == true) {
          try {
            await axios.delete(`${baseApiUrl}Produtos/${item.id}?access_token=${sessionStorage.getItem('accToken')}`)
            this.carregaProdutos(this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.companyobj.id, this.user.tipo == 'ADMIN' || this.user.tipo == 'ADMIN_PRODUTORA' ? this.lojistaSelecionado : this.user.lojistaId)
          } catch (error) {
            var vm;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
          }
        }
      },

      formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      async salvarProduto() {
        var vm = this

        if (this.produto.descricao && this.produto.ordem && this.produto.preco && this.produto.status && this.produto.urlImagem) {
          this.produto.empresaId = this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.companyobj.id
          this.produto.lojistaId = this.user.tipo == 'ADMIN' || this.user.tipo == 'ADMIN_PRODUTORA' ? this.lojistaSelecionado : this.user.lojistaId

          await axios.post(baseApiUrl + 'Produtos/replaceOrCreate?access_token=' + sessionStorage.getItem('accToken'), this.produto)
          .then(response => {
            if (response.data) {
              this.dialogoProduto = false
              this.carregaProdutos(this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.companyobj.id, this.user.tipo == 'ADMIN' || this.user.tipo == 'ADMIN_PRODUTORA' ? this.lojistaSelecionado : this.user.lojistaId)
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar operação, tente novamente", "DESCULPE")
          })
        } else {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha todos os campos!", "ATENÇÃO")
        }
      },
    },

    directives: {money: VMoney}
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
    font-size: 14px;
  }
</style>
